export default __webpack_public_path__ + "static/media/d517e0cf805a7e46cfe9b2a17f93f701.svg";